import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
    Box,
    Button,
    Chip,
    Link,
    MenuItem,
    Select,
    Skeleton,
    Stack,
    Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { BackArrowIcon, DotsIcon, ExportIcon, EyeIcon, UsersIcon } from '../../icons';

import { GlobalStyles } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useNotification } from '../../hooks/useNotification';
import UpdateCounselingStatusModal from '../../components/University/counseling/UpdateCounselingStatus';
import CounselingDetailsModal from '../../components/University/counseling/CounselingDetaills';
import { useDispatch } from 'react-redux';
import CommonTableFormat from '../../components/common/CommonTableFormat';
import CommonFilterTab from '../../components/common/CommonFilterTab';
import { useLocation } from 'react-router-dom';
import { setPaginationFiled } from '../../containers/pagination-container/reducer/paginationSlice';
import { formatMultiQueryParams, getStatusColors, jsonParserFormatter } from '../../utils/helperFunction';
import AssignCouncilorModal from '../../components/councilor/AssignCouncilorModal';
import { assignCouncilorToCounselingLead, downloadWebLeads, fetchCounselingUtmType, fetchUniversityCounselingFormList } from '../../api/counselingApi';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import Tooltip from '@mui/material/Tooltip';
import { IconButton } from '@mui/material';
import { defaultPaginationValues, filterTypeOptions, webLeadsStatusList } from '../../utils/constant';
import { setFilterField } from '../../containers/filter-container/reducer/filterSlice';
import CommonDataTable from '../../components/common/CommonDataTable';

const AdminUniversityCounseling = ({ activeTab }) => {
    const filterSlice = useSelector(state => state.filter?.filters)
    const LOCATION_FILTER = `filters_${activeTab}:${window.location.pathname}`
    const dispatch = useDispatch()
    const paginationSlice = useSelector(state => state.pagination)
    const location = useLocation()
    const [rows, setRows] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [selectedCounseling, setSelectedCounseling] = useState(null);
    const [updateStatusOpen, setUpdateStatusOpen] = useState(false);
    const [detailModalOpen, setDetailModalOpen] = useState(false);
    const [assignOpen, setAssignOpen] = useState(false);
    const pagintionDefaultVal = (paginationSlice?.pathname == location?.pathname && paginationSlice?.filters) || { page: 0, pageSize: 50 }
    const [paginationModel, setPaginationModel] = React.useState(pagintionDefaultVal)
    const [searchFilter, setSearchFilter] = React.useState({})
    const [rowCount, setRowCount] = useState(0);
    const [downloading, setDownloading] = useState(false)
    const [utmTypeList, setUtmTypeList] = React.useState([]);
    const { showSuccessNotification, showErrorNotification, } = useNotification()
    const [pageFilters, setPageFilters] = React.useState(defaultPaginationValues);
    const [isRender, setIsRender] = React.useState(false)

    const handleFliterSliceChange = (values = {}, isReset = false) => {
        let isQuery = typeof values === "object" && Object.keys(values)?.length
        isQuery && dispatch(setFilterField({ pathname: LOCATION_FILTER, filters: JSON.stringify({ ...(isReset ? {} : pageFilters), ...defaultPaginationValues, ...values }) }))
    }


    const fetchDetails = () => {
        const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
        fetchUniversityCounselingFormList({ setRows, filterData: { ...searchFilter, ...multiFilter, isMultiFilter: true }, setRowCount })
            .then(res => {
                setLoading(false)
            }).catch(error => {
                showErrorNotification(error?.message)
            })
    }

    const fetchUtmDetails = () => {
        fetchCounselingUtmType({ setUtmTypeList })
            .catch(error => {
                showErrorNotification(error?.message)
            })
    }

    useEffect(() => {
        fetchDetails()
    }, [filterSlice[LOCATION_FILTER], isRender])

    // handle extra filter tabs changes
    React.useEffect(() => {
        if (pageFilters?.page) {
            handleFliterSliceChange({ page: 0 })
        } else {
            setIsRender(!isRender)
        }
    }, [searchFilter])

    // parse page filters
    React.useEffect(() => {
        const values = jsonParserFormatter(filterSlice[LOCATION_FILTER])
        setPageFilters(values)
    }, [filterSlice[LOCATION_FILTER]])

    useEffect(() => {
        fetchUtmDetails()
    }, [])



    const columns = [
        {
            field: 'sNo',
            headerName: 'S. No.',
            width: 60,
            sortable: false,
            filterable: false,
            disableColumnMenu: false,
            // renderCell: (params) => rows?.findIndex((r) => r.id === params.row.id) + 1,
        },
        {
            field: 'studentDetails',
            headerName: 'Student Details',
            flex: 2,
            minWidth: 280,
            filterColumnName: "name",
            filterType: filterTypeOptions.string,
            renderCell: (params) => {
                const { img, studentDetails } = params.row;

                const getInitials = (fullName) => {
                    if (!fullName) return '';
                    const words = fullName.trim().split(' ').filter(Boolean);
                    if (words.length === 1) return words[0][0]?.toUpperCase() || '';
                    if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase();
                    return (words[0][0] + words[1][0] + words[2][0]).toUpperCase();
                };

                const stringToColor = (str) => {
                    let hash = 0;
                    for (let i = 0; i < str.length; i++) {
                        hash = str.charCodeAt(i) + ((hash << 5) - hash);
                    }
                    const c = (hash & 0x00ffffff).toString(16).toUpperCase();
                    return '#' + '00000'.substring(0, 6 - c.length) + c;
                };

                const bgColor = stringToColor(studentDetails || 'Course');

                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        sx={{ cursor: 'pointer' }}
                    >
                        {img ? (
                            <Box
                                component="img"
                                src={img}
                                alt="logo"
                                sx={{
                                    width: 40,
                                    height: 40,
                                    padding: '5px',
                                    borderRadius: '50%',
                                    objectFit: 'contain',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                                    display: 'block',
                                    maxHeight: 60,
                                }}
                            />
                        ) : (
                            <Box
                                sx={{
                                    minWidth: 35,
                                    minHeight: 35,
                                    maxWidth: 35,
                                    maxHeight: 35,
                                    borderRadius: '50%',
                                    backgroundColor: bgColor,
                                    color: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 500,
                                    fontSize: '10px',
                                    textTransform: 'uppercase',
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                                }}
                            >
                                {getInitials(studentDetails)}
                            </Box>
                        )}
                        {params.value}
                    </Box>
                );
            },
        },

        {
            field: 'phoneNumber',
            headerName: 'Phone Number',
            flex: 1.2,
            minWidth: 160,
            cellClassName: 'fw-bold',
            filterColumnName: "phone",
            filterType: filterTypeOptions.string,
        },
        {
            field: 'emailID',
            headerName: 'Email ID',
            flex: 1,
            minWidth: 250,
            filterColumnName: "email",
            filterType: filterTypeOptions.string,
        },
        {
            field: 'university',
            headerName: 'Course & University',
            flex: 2,
            minWidth: 260,
            filterColumnName: "course",
            filterType: filterTypeOptions.string,
            renderCell: (params) => {
                const { universityName, course } = params.row;
                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box display="flex" sx={{ height: '100%', flexDirection: 'column', justifyContent: 'center', }}>
                        <Typography sx={{ fontSize: '13px !important', color: '#1075FF', fontWeight: 500 }}>
                            {course}
                        </Typography>

                        {/* Course Name */}
                        <Typography
                            sx={{
                                fontSize: '11px !important',
                                fontWeight: 500,
                                color: '#6E7485',
                                paddingTop: '4px',
                            }}
                        >
                            {universityName}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: 'source',
            headerName: 'Source',
            flex: 1,
            minWidth: 180,
            filterColumnName: "source",
            filterType: filterTypeOptions.string,
        },
        {
            field: 'leadSource',
            headerName: 'Lead Source',
            flex: 1,
            minWidth: 160,
            filterColumnName: "utmData.utm_campaign",
            filterType: filterTypeOptions.string,
            renderCell: (params) => {
                const leadSource = params.value;
                if (loading) return <Skeleton width={70} />;

                const words = leadSource ? leadSource.split(" ") : [];
                const preview = words.slice(0, 7).join(" ") + (words.length > 7 ? "..." : "");

                return (
                    <Box sx={{ display: 'flex', gap: '3px', alignItems: 'center', height: '100%' }}>
                        <Typography noWrap sx={{ maxWidth: 200 }}>
                            {preview}
                        </Typography>

                        <Tooltip
                            title={
                                <Box sx={{ maxWidth: 300, whiteSpace: "normal" }}>
                                    <Typography variant="body2">{leadSource}</Typography>
                                </Box>
                            }
                            placement="top"
                            arrow
                        > {
                                preview ? (
                                    <IconButton size="small">
                                        <RemoveRedEyeOutlinedIcon fontSize="small" sx={{ color: '#313030', fontSize: '17px' }} />
                                    </IconButton>
                                ) : (
                                    ''
                                )
                            }
                        </Tooltip>
                    </Box>
                );
            },
        },
        {
            field: 'dob',
            headerName: 'DOB',
            flex: 1.2,
            minWidth: 160,
            cellClassName: 'fw-bold',
            filterColumnName: "dob",
            filterType: filterTypeOptions.dateRange,
        },
        {
            field: 'message',
            headerName: 'Message',
            flex: 1.2,
            minWidth: 160,
            cellClassName: 'fw-bold',
            filterColumnName: "message",
            filterType: filterTypeOptions.string,
            renderCell: (params) => {
                const message = params.value;
                if (loading) return <Skeleton width={70} />;

                const words = message ? message.split(" ") : [];
                const preview = words.slice(0, 7).join(" ") + (words.length > 7 ? "..." : "");

                return (
                    <Box sx={{ display: 'flex', gap: '3px', alignItems: 'center', height: '100%' }}>
                        <Typography noWrap sx={{ maxWidth: 200 }}>
                            {preview}
                        </Typography>

                        <Tooltip
                            title={
                                <Box sx={{ maxWidth: 300, whiteSpace: "normal" }}>
                                    <Typography variant="body2">{message}</Typography>
                                </Box>
                            }
                            placement="top"
                            arrow
                        > {
                                preview ? (
                                    <IconButton size="small">
                                        <RemoveRedEyeOutlinedIcon fontSize="small" sx={{ color: '#313030', fontSize: '17px' }} />
                                    </IconButton>
                                ) : (
                                    ''
                                )
                            }

                        </Tooltip>
                    </Box>
                );
            },
        },

        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            minWidth: 130,
            filterColumnName: "status",
            filterType: filterTypeOptions.selection,
            selection: webLeadsStatusList,
            renderCell: (params) => {
                const { status } = params.row;
                const { brdColor, textColor } = getStatusColors(status);


                return loading ? (
                    <Skeleton width={70} />
                ) : (
                    <Chip
                        label={params.value}
                        size="small"
                        sx={{
                            bgcolor: brdColor || '#eee',
                            color: textColor || '#000',
                            fontWeight: 500,
                            textTransform: 'capitalize'
                        }}
                    />
                )
            }
        },
        {
            field: 'submitted',
            headerName: 'Submitted',
            flex: 1,
            minWidth: 130,
            cellClassName: "fw-bold",
            filterColumnName: "createdAt",
            filterType: filterTypeOptions.dateRange,
        },
        {
            field: 'assignedTo',
            headerName: 'Assigned To',
            flex: 2,
            minWidth: 180,
            filterColumnName: "counselorId.firstName",
            filterType: filterTypeOptions.string,
            renderCell: (params) => {
                const { img, assignedTo } = params.row;

                const getInitials = (fullName) => {
                    if (!fullName) return '';
                    const words = fullName?.trim().split(' ').filter(Boolean);
                    if (words.length === 1) return words[0][0]?.toUpperCase() || '';
                    if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase();
                    return (words[0][0] + words[1][0] + words[2][0]).toUpperCase();
                };

                const stringToColor = (str) => {
                    let hash = 0;
                    for (let i = 0; i < str.length; i++) {
                        hash = str.charCodeAt(i) + ((hash << 5) - hash);
                    }
                    const c = (hash & 0x00ffffff).toString(16).toUpperCase();
                    return '#' + '00000'.substring(0, 6 - c.length) + c;
                };

                const bgColor = stringToColor(assignedTo || 'Course');

                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        sx={{ cursor: 'pointer' }}
                    >
                        {img ? (
                            <Box
                                component="img"
                                src={img}
                                alt="logo"
                                sx={{
                                    width: 40,
                                    height: 40,
                                    padding: '5px',
                                    borderRadius: '50%',
                                    objectFit: 'contain',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                                    display: 'block',
                                    maxHeight: 60,
                                }}
                            />
                        ) : (
                            assignedTo ? <Box
                                sx={{
                                    minWidth: 35,
                                    minHeight: 35,
                                    maxWidth: 35,
                                    maxHeight: 35,
                                    borderRadius: '50%',
                                    backgroundColor: bgColor,
                                    color: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 500,
                                    fontSize: '10px',
                                    textTransform: 'uppercase',
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                                }}
                            >
                                {getInitials(assignedTo)}
                            </Box> : ""
                        )}
                        {params.value}
                    </Box>
                );
            },
        },

        {
            field: 'action',
            headerName: 'Action',
            width: 250,
            filterable: false,
            renderCell: (params) =>
                loading ? <Skeleton width={80} /> : <Stack direction="row" spacing={1} sx={{ justifyContent: 'start', height: '100%' }}>
                    {!params?.row?.isRegistrationDone && <Button onClick={() => { setUpdateStatusOpen(true); setSelectedCounseling(params?.row) }}
                        size="small"
                        variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', }}
                        startIcon={<DotsIcon />}
                    >
                    </Button>}
                    <Button onClick={() => { setDetailModalOpen(true); setSelectedCounseling(params?.row) }}
                        size="small"
                        variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', }}
                        startIcon={<EyeIcon />} >
                    </Button>
                    {!params?.row?.isRegistrationDone && <Button onClick={() => { setAssignOpen(true); setSelectedCounseling(params?.row) }}
                        size="small"
                        variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', }}
                        startIcon={<UsersIcon />} >
                    </Button>}
                </Stack>,
        },

    ];

    const assignCounsilorInfo = {
        _id: selectedCounseling?.id,
        student: selectedCounseling?.studentDetails,
        universityName: selectedCounseling?.universityName,
        status: selectedCounseling?.status,
    }

    return (
        <>
            {/* Apply global styles to DataGrid dropdown menus */}

            <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', marginBottom: '12px' }}>

                    <div className="row align-items-center">
                        <div className="col">
                            <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}>
                                {/* <Link href="/university-listing-management" className='d-flex'><BackArrowIcon /></Link> */}
                                University Counseling</Typography>
                        </div>
                        {/* End Col */}
                    </div>
                    {/* End Col */}
                </div>

                {/* <Box sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    my: 2,
                    px: 2,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                    <Box>
                    </Box>
                    <Button
                        variant="contained"
                        color="#363853"
                        startIcon={<ExportIcon />}
                        disabled={downloading}
                        onClick={downloadLeadDetails}
                        sx={{
                            background: '#EFEFEF',
                            border: '1px solid #E6E7E8',
                            borderRadius: '8px',
                            textTransform: "none", // Capitalization remove
                            fontWeight: 500
                        }}
                    >
                        Export
                    </Button>
                </Box> */}

                {/* Filter Toolbar */}
                <CommonFilterTab type='counseling-leads' module='web' searchPlaceholder='Search by Name/Mobile...' detailType='Counseling Overview' fetchList={setSearchFilter} showCount={rows?.length} rowCount={rowCount} isExportBtn={true} isUtmFilter={true} utmFilterOptions={utmTypeList} />

                {/* Data Table */}
                <CommonDataTable columns={columns} rows={rows} idKey="field" loading={loading} filterEnabled={true} rowCount={rowCount}
                    pageFilters={pageFilters}
                    handleFliterSliceChange={handleFliterSliceChange}
                    otherPath={activeTab}
                />
            </Box>

            {selectedCounseling && <UpdateCounselingStatusModal refetch={fetchDetails} counseling={selectedCounseling} open={updateStatusOpen} onClose={() => setUpdateStatusOpen(false)} />}
            {detailModalOpen && <CounselingDetailsModal counseling={selectedCounseling} open={detailModalOpen} onClose={() => setDetailModalOpen(false)} />}
            <AssignCouncilorModal
                info={assignCounsilorInfo}
                assignCouncilorToCall={assignCouncilorToCounselingLead}
                refetch={fetchDetails}
                open={assignOpen}
                onClose={() => setAssignOpen(false)}
            />

        </>
    )
}

export default AdminUniversityCounseling
